export enum SatisfactionAnswerType {
    HAPPY = 'happy',
    SAD = 'sad',
}



// WEBPACK FOOTER //
// ./ts/app/shared/live-class-survey/live-class-survey-data-types.ts